<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-30">
      <el-container>
        <el-aside width="330px">
          <sidebar></sidebar>
        </el-aside>
        <el-main>
          <div v-if="isTag == true"   class="tips">您还没有完成资质审核，还不能发布产品等其他信息，请先完成资质审核</div>
          <comentTitle
            :class="[isTag == true?'m-t-30':'']"
            :comentTitle="comentTitle"
            :comentText="comentText"
            @onEitd="onEitdInfo()"
          ></comentTitle>
          <companySide class="mt-20" :isButton="isButton" @release="gorelease()"></companySide>
          <div class="mt-30">
            <contTitle :obj="obj" :contTitle="contTitle1"></contTitle>
            <div class="mt-20 fdc">
              <div class="nav background1">
                <span @click="onProduct()">产品</span>
                <span></span>
               <span>{{countObj.sup}}</span>
			   <!-- <interval-number :number-content="countObj.sup" v-if="countObj.sup>0"></interval-number> -->
              </div>
              <div class="nav background2">
                <span @click="onReal()">资讯</span>
                <span></span>
				 <!-- <interval-number :number-content="countObj.ind" v-if="countObj.ind>0"></interval-number> -->
                <span>{{countObj.ind}}</span>
              </div>
              <div class="nav background3">
                <span @click="onCase()">案例</span>
                <span></span>
				<!-- <interval-number :number-content="countObj.exa" v-if="countObj.exa>0"></interval-number> -->
                <span>{{countObj.exa}}</span>
              </div>
              <div class="nav background4">
                <span @click="onMeans()">资料</span>
                <span></span>
				<!-- <interval-number :number-content="countObj.fil" v-if="countObj.fil>0"></interval-number> -->
                <span>{{countObj.fil}}</span>
              </div>
               <div class="nav background5">
                <span @click="onDemand()">需求</span>
                <span></span>
				<!-- <interval-number :number-content="countObj.dea" v-if="countObj.dea>0"></interval-number> -->
                <span>{{countObj.dea}}</span>
              </div>
               <div class="nav background6">
                <span @click="onProblem()">问题</span>
                <span></span>
				<!-- <interval-number :number-content="countObj.que" v-if="countObj.que>0"></interval-number> -->
                <span>{{countObj.que}}</span>
              </div>
            </div>


             <!--生意助手-->
             <div class="mt-30" v-if="helper">
                <contTitle class="mt-20" :obj="obj" :contTitle="contTitle2"></contTitle>
                <div class="account_mater">
                   <div class="account_tip" v-for="(item,index) in cailList" :key="index">
                      <p :class="[active == index?'active_coler':'ml-20']" @click.prevent="onHide(item)">{{item.text}}</p>
                   </div>
                </div>
              
               <!--列表-->
               <pictureLeftList  :list="nubmerList"  v-if="account"  class="mt-20"></pictureLeftList>
               <!--分页-->
              <Pagination v-show="total>0"   :total="total"  :page.sync="listQuery.curPage" :limit.sync="listQuery.limit" @pageChange="pageChange" ></Pagination>
              <div  v-if="isMakr == true"  class="suup_upgrage" @click="onPay()">升级为企业VIP会员，您可以查看用户浏览足迹或浏览历史</div>
             </div>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
import {myBrowseList,getCount} from "@/api/coment"
import sidebar from "../../common/sidebar";
import companySide from "../../common/companySide";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import paletteBar from "../../common/paletteBar";
import contTitle from "../../common/contTitle";
import comentTitle from "../../common/comentTitle";
import pictureLeftList from "../../components/pictureLeftList";
import Pagination from '../../components/Pagination'
import intervalNumber  from '../../components/intervalNumber'
import { formatTime } from '../../utils';
export default {
  components: {
    sidebar,
    companySide,
    commBanner,
    titleHead,
    paletteBar,
    contTitle,
    comentTitle,
    pictureLeftList,
    Pagination,
	intervalNumber
  },
  data() {
    return {
      headTitle: "企业账户",
      contTitle1: "发布信息",
      contTitle2: "生意助手",
      comentTitle: "企业基本信息",
      comentText: "编辑企业信息  >",
      obj: {
        title: "企业账户",
        isShow: false,
        isColor:false,
        roleType:3,
        personalType:9
      },
      listQuery:{
        curPage:1,
        limit:4,
        goodsType:6
      },
      
      total:0,//当前条数
      nubmerList:[], //浏览人数
      isButton:false,
      countObj:{},
      isTag:true,
      isMakr:false,
      account:false,
      helper:false,
      active:0,
      content:'产品',
      cailList:[
          {'text':'产品',index:0,type:6},
          {'text':'资料',index:1,type:1},
          {'text':'需求',index:2,type:8},
          // {'text':'资料',index:3,type:1},
          // {'text':'课程',index:4,type:4},
          // {'text':'专家',index:5,type:9},
          // {'text':'资讯',index:6,type:2}
      ]
    };
  },
  created(){
    this.getNubmer();
    this.getCountList();
    this.getMate();
    let obj = this.$store.state.user.userInfo.data2;
    if(this.$store.state.user.userInfo.data.status == 1){  //认证通过
        this.isTag = false;   
        this.isMakr = true; 
    }else{
        this.isTag = false
    }
    if(obj.id == 5){
       this.isMakr = false;
       this.helper = true;
    }
  },
  methods: {
    //产品
    onProduct(){
      this.$router.push('/corporate_supply')
    },
    //资讯
    onReal(){
       this.$router.push('/corporate_list')
    },
    //案列
    onCase(){
       this.$router.push('/corporate_case')
    },
    //资料
    onMeans(){
       this.$router.push('/means')
    },
    //需求
    onDemand(){
       this.$router.push('/demand')
    },
    onProblem(){
       this.$router.push('/problem')
    },
    //切换内容
    onHide(item){
      this.active = item.index;
      this.content =  item.text;
      this.listQuery.goodsType = item.type;
      this.getNubmer();
    },
	formatter(num){
	  return num;
	},
    //编辑账号信息
    onEitdInfo(){
      this.$router.push('/personal_information')
    },
     //浏览人数列表
    getNubmer(){
      myBrowseList(this.listQuery).then((res)=>{
        if(res.code == 0){
          this.nubmerList = res.page.list;
          this.total = res.page.totalCount;
          this.account = true 
        }
      }).catch((err)=>{})
    },
    pageChange(item){
      this.listQuery['curPage'] = item.page;
      this.listQuery['limit'] = item.limit;
      this.getNubmer();
    },
    getCountList(){
	  let params ={};
      getCount(params).then((res)=>{
         if(res.code == 0){
           this.countObj = res.data;
         }
      }).catch((err)=>{})
    },
    //发布需求
    gorelease(){
      this.$router.push('/demand')
    },
    //升级缴费
    onPay(){
      this.$router.push('/corporate_member')
    },
    getMate(){
        var metas = document.getElementsByTagName("meta"); 
        document.getElementsByTagName("title")[0].innerText= this.$route.meta.title +'_智污邦环保服务平台';
    },
  },
};
</script>
<style scoped>
/* .el-aside{
  height: 930px;
} */
.mt-20 {
  margin-top: 20px;
}
.m-t-30 {
  margin-top: 30px;
}
.tips {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #e28b8b;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.nav {
  display: flex;
  flex-direction: column;
  align-content: center;
  padding: 10px 35px;
  width: 14%;
  height: 80px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-align: left;
}
.background1 {
  background: #f1c321;
}
.background2 {
  background: #ff9000;
}
.background3 {
  background: #acd71b;
}
.background4 {
  background: #5aba3e;
}
.background5{
  background: #F0E68C;
}
.background6{
  background: #FA8072;
}
.account_mater{
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
  background: #5aba3e;
}
.account_tip {
  margin: 0px 10px;
  font-size: 14px;
  color: #ffffff;
  width: 40px;
}
.account_mater p{
  width: 40px;
  display: inline-block;
}
.account_mater p:hover{
  cursor: pointer;
}
.active_coler{
   border-bottom: 2px solid  #ffffff;
}

.nav span:first-child {
  font-size: 14px;
  width: 30px;
}
.nav span:nth-child(2) {
  width: 20px;
  height: 1px;
  border: 1px solid #ffffff;
  margin-left: 15%;
  margin-top: 6px;
}
.nav span:last-child {
  font-size: 20px;
  margin-top: 6px;
}
.el-pagination {
  margin-top: 40px;
}
.suup_upgrage{
  margin-top: 30px;
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #e28b8b;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/view/company/corporate_account.vue